import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const removeRangeData = index => ({
  type: types.REMOVE_RANGE_DATA,
  index,
});

export {
  init, fetching, fetchData, removeRangeData,
};
